import IconSubmittals from '@/assets/svgs/submittals-icon.svg?react'
import { NavigationLink } from '@/components/NavigationLink'
import { getDexConfig } from '@/utils/getDexConfig'
import { getEnvAndDex } from '@/utils/getEnvAndDex'

export const Navigation = () => {
  const { dex } = getEnvAndDex()
  const { LogoComponent: Logo } = getDexConfig(dex)

  return (
    <div>
      <div className="flex items-center justify-center pt-9.25 type-body-2 text-[1rem] [&_svg]:w-[86px] [&_svg]:h-[33px]">
        <Logo />
        <span className="text-grey-50 pl-2"></span>
      </div>
      <div className="mt-12.75">
        <div className="-mt-4">
          <div className="mt-2.5 first:mt-0">
            <NavigationLink to="/submittals" icon={<IconSubmittals />} text="Submittals" />
          </div>
        </div>
      </div>
    </div>
  )
}
